import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { FACILITY_ROLES } from "@src/constants/facility";
import { isAfter } from "date-fns";

const useFacilityOnboardingFlag = (props: {
  workplaceCreationDate?: string;
  roles: FACILITY_ROLES[];
  isAdmin: boolean;
  isWorkplace: boolean;
}): boolean => {
  const { roles, isAdmin, workplaceCreationDate, isWorkplace } = props;

  const { minimumWorkplaceCreationDate } = useCbhFlag(CbhFeatureFlag.HCF_ONBOARDING, {
    defaultValue: {},
  });

  const hasPermission =
    roles.includes(FACILITY_ROLES.ADMIN) || roles.includes(FACILITY_ROLES.SHIFT_MANAGEMENT);

  if (
    isAdmin ||
    !isWorkplace ||
    !hasPermission ||
    !isDefined(minimumWorkplaceCreationDate) ||
    !isDefined(workplaceCreationDate)
  ) {
    return false;
  }

  return isAfter(new Date(workplaceCreationDate), new Date(minimumWorkplaceCreationDate));
};

export { useFacilityOnboardingFlag };
